module.exports = __webpack_public_path__ + "assets/img/Logo-AXA.6239150a.png";